import gql from 'graphql-tag'

const GENERATE_XLSX_MUTATION = gql`
  mutation GenerateXlsx($input: GenerateXlsxInput!) {
    generateXlsx(input: $input) {
      base64
      fileName
      contentType
    }
  }
`

export async function exportExcel(apolloClient, filename, workbook) {
  try {
    const { data } = await apolloClient.mutate({
      mutation: GENERATE_XLSX_MUTATION,
      variables: {
        input: {
          name: workbook.name,
          sheets: workbook.sheets
        }
      }
    })

    const { base64, contentType } = data.generateXlsx

    const byteCharacters = atob(base64)
    const byteNumbers = new Array(byteCharacters.length)
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i)
    }
    const byteArray = new Uint8Array(byteNumbers)
    const blob = new Blob([byteArray], { type: contentType })

    const downloadName = filename + '.xlsx'

    if (window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(blob, downloadName)
    } else {
      const a = document.createElement('a')
      const url = URL.createObjectURL(blob)
      a.href = url
      a.target = '_blank'
      a.download = downloadName
      document.body.appendChild(a)
      a.click()
      URL.revokeObjectURL(url)
      document.body.removeChild(a)
    }
  } catch (err) {
    console.log(err)
  }
}
